import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ProviderProductsToPdf from "./../../ProviderProducts/ProviderProductsToPdf.jsx";
import api from "../../../../utils/axios";


export default function PdfExportModal({ show, onClose, providers, isLoaded }) {
  const [selectedProvider, setSelectedProvider] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [showError, setShowError] = useState(false);
  const [selectedProviderName, setSelectedProviderName] = useState("");

  useEffect(() => {
    if (selectedProvider) {
      async function getDataProducts() {
        const result = await api.get("/productos");

        const products = result.data.products;

        const otherProductsResponse = await api.get("/otros_productos");

        const otherProducts = otherProductsResponse.data.products;

        const combinedProducts = [...products, ...otherProducts];

        const filteredProductsByProviderId = combinedProducts.filter(
          (product) =>
            product.provider && product.provider._id === selectedProvider
        );

        setFilteredProducts(filteredProductsByProviderId);
      }
      getDataProducts();
    } else {
      setFilteredProducts([]);
    }
  }, [selectedProvider]);

  // Resetear estado al cerrar modal
  useEffect(() => {
    if (!show) {
      setFilteredProducts([]);
      setSelectedProvider("");
      setShowError(false);
    }
  }, [show]);

  // Validar cuando clickea generar
  const isValid = selectedProvider && filteredProducts.length > 0;

  const handleGenerateClick = () => {
    if (!isValid) {
      setShowError(true);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      centered
      size="md"
    >
      <Modal.Header closeButton>
        <Modal.Title>Descargar productos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Selecciona un proveedor para generar el PDF</p>
        <Form style={{ marginTop: "10px" }}>
          {isLoaded && (
            <Form.Select
              className="select-provider"
              value={selectedProvider}
              style={{ width: "100%", height: "45px", fontSize: "14px" }}
              onChange={(e) => {
                const id = e.target.value;
                setSelectedProvider(id);

                const provObj = providers.find((p) => p._id === id);
                setSelectedProviderName(provObj ? provObj.name : "");
              }}
            >
              <option value="" disabled>
                Seleccionar
              </option>
              {providers.map((provider) => (
                <option key={provider._id} value={provider._id}>
                  {provider.name}
                </option>
              ))}
            </Form.Select>
          )}

          {/* Mensaje si no seleccionó proveedor */}
          {showError && !selectedProvider && (
            <div style={{ color: "red", marginTop: "10px", fontSize: "14px" }}>
              Selecciona un proveedor antes de generar el PDF.
            </div>
          )}

          {/* Mensaje si no hay productos */}
          {showError && selectedProvider && filteredProducts.length === 0 && (
            <div style={{ color: "red", marginTop: "10px", fontSize: "14px" }}>
              No se encontraron productos para este proveedor.
            </div>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer
        style={{ justifyContent: "flex-end", alignItems: "center" }}
      >
        <Button variant="secondary" onClick={onClose}>
          Cancelar
        </Button>

        {isValid ? (
          <PDFDownloadLink
            document={<ProviderProductsToPdf products={filteredProducts} />}
            fileName={`Productos-${selectedProviderName.replace(
              /\s+/g,
              "_"
            )}.pdf`}
          >
            <Button
              variant="success"
              style={{ backgroundColor: "#056a6c", color: "white" }}
            >
              Generar
            </Button>
          </PDFDownloadLink>
        ) : (
          <Button
            variant="success"
            onClick={handleGenerateClick}
            style={{ backgroundColor: "#056a6c", color: "white" }}
          >
            Generar
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
